import { useFormContext } from 'react-hook-form';
import { ApplicationDataBaseField } from '../Fields/ApplicationDataBaseField';
import { ApplicationDataFormValues } from '../ApplicationDataForm/ApplicationDataFormSchema';
import { currencyFormatter } from '@axo/shared/util/formatters';
import { useLoanApplication } from '@axo/shared/data-access/hooks';

interface RefinanceAmountFieldProps {
  applicationID: string;
}

export const RefinanceAmountField: React.FC<RefinanceAmountFieldProps> = ({
  applicationID,
}) => {
  const { data: applicationData } = useLoanApplication(applicationID);

  const { watch } = useFormContext<ApplicationDataFormValues>();
  const debts = watch('Debts');

  const refinanceAmount = debts?.reduce(
    (current, debt) => current + (debt.RefinanceAmount ?? 0),
    0,
  );

  return (
    <ApplicationDataBaseField
      applicationID={applicationID}
      label="Ref. amount"
      valueElement={
        refinanceAmount
          ? currencyFormatter(
              refinanceAmount,
              applicationData?.Currency ?? undefined,
              0,
            )
          : '-'
      }
      horizontal
    />
  );
};
